module.exports = __webpack_public_path__ + "img/disrupt-grey.b2a41f31.png";